import styled from "styled-components";

export const SliderContainer = styled.div`
  padding: 0 8px;
  margin-bottom: 40px;

  .slick-prev {
    left: -40px;
  }
  .slick-next {
    right: -40px;
  }

  .slick-arrow {
    background-color: ${(props) => props?.colorTheme ?? "#1d3054"};
    height: 40px;
    width: 40px;
    border-radius: 100%;
    z-index: 99;
  }

  .slick-dots {
    display: none !important;
  }
  .slick-track {
    margin-left: 8px !important;
  }
`;

export const Card = styled.div`
  width: calc(100% - 16px) !important;
  border: 1px solid #848484;
  box-shadow: 0px 4px 8px -2px rgba(77, 77, 77, 0.1),
    0px 2px 4px -2px rgba(77, 77, 77, 0.06);
  border-radius: 8px;
  min-height: 412px;
  height: 100%;
  overflow: hidden;
  position: relative;
`;

export const CardHeader = styled.div`
  padding: 16px;

  span {
    color: #ffffff;
    font-size: 12px;
  }
  position: relative;
  display: block;
  top: 0;
`;
export const CardBody = styled.div`
  padding: 16px;
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 56px;
  bottom: 0;
  right: 0;
  left: 0;

  .title {
    font-size: 16px;
    color: #4d4d4d;
    font-weight: bold;
    margin-bottom: 8px;
    &:nth-child(3) {
      margin-top: 16px;
    }
  }
  .description {
    color: #4d4d4d;
    font-size: 14px;
    margin: 0;
    margin-top: 4px;
  }
  .descriptionText {
    height: 56px;
    overflow-y: ${({ descriptionLength }) =>
      descriptionLength > 360 ? "scroll" : "auto"};
  }
`;

export const EditButton = styled.button`
  width: 100%;
  color: ${({ color }) => color};
  font-size: 12px;
  font-weight: bold;
  border: 2px solid;
  border-radius: 4px;
  text-align: center;
  padding: 4px;
  justify-content: center;
  display: flex;
  align-items: center;
  cursor: pointer;
  background-color: transparent;
  transition: 0.3s;
  span {
    text-shadow: none;
    width: 100%;
    height: 100%;
    display: block;
    transition: 0.3s;
  }
  &:hover {
    span {
      text-shadow: 0 0 0.1em #f87, 0 0 0.1em #f87;
    }
  }
  &:disabled {
    color: #d1d1d1;
    cursor: auto;
    &:hover {
      span {
        text-shadow: none;
      }
    }
  }
`;

export const DescriptionField = styled.textarea`
  word-wrap: break-word;
  resize: none;
  width: calc(100% - 32px);
  font-size: 10px;
  height: 56px;
  color: #4d4d4d;
  font-weight: bold;
  padding: 8px;
`;

export const ContainerButtonsRepair = styled.div`
  margin-top: 16px;
  width: calc(100% - 35px);
  display: flex;
  justify-content: space-between;
  gap: 16px;
  position: absolute;
  bottom: 16px;
`;

export const RepairNumber = styled.div`
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 24px;
  background-color: #1d3054;
  border-radius: 8px;
  width: 127px;
  height: 40px;
  color: #fff;
  font-size: 16px;
  font-weight: 700;
  background-color: ${({ tema }) => tema?.primaryColor};
`;
